module.exports = __webpack_public_path__ + "static/assets/7817f6ce2f56bf86a3b284e2ac7d2dad.svg";